<template>
  <v-data-table ref="dataTable" dense v-model="selected" :headers="computedHeaders" :items="computedRecords"
    :single-select="singleSelect" item-key="id" show-select :items-per-page="15" class="custom-select-table">
  </v-data-table>
</template>

<script>
export default {
  props: {
    /** Data to be displayed in the table */
    tableData: { type: Array, required: false, default: null }
  },
  data () {
    return {
      singleSelect: false,
      selected: [],
      headers: [
        { text: '序号', value: 'row_number', width: '60px' },
        { text: '被保险人姓名', value: 'insured_name' },
        { text: '被保险人组织机构代码/身份证号', value: 'id_number' },
        { text: '农补"一卡通"卡号', value: 'bank_card' },
        { text: '地块', value: 'plot_info' },
        { text: '保险数量（亩）', value: 'area_mu' },
        { text: '保险金额', value: 'insurance_amount' },
        { text: '总保险费', value: 'subsidy_premium' },
        { text: '农户自交保费', value: 'farmer_premium' },
        { text: '联系电话', value: 'phone_number' },
        { text: '农户签字', value: 'signature', sortable: false }
      ]
    }
  },
  computed: {
    computedHeaders () {
      return this.headers
    },
    computedRecords () {
      const records = this.tableData || [];
      return records?.map(record => ({
        ...record,
        area_mu: record.area_mu ? parseFloat(record.area_mu).toFixed(2) : '',
        insurance_amount: record.insurance_amount ? parseFloat(record.insurance_amount).toFixed(2) : '0.00',
        farmer_premium: record.farmer_premium ? parseFloat(record.farmer_premium).toFixed(2) : '0.00',
        subsidy_premium: record.subsidy_premium ? parseFloat(record.subsidy_premium).toFixed(2) : '0.00',
        policy_start_date: record.policy_start_date ? new Date(record.policy_start_date).toLocaleDateString() : '',
        signature: '' // Add empty signature field for signing
      }));
    }
  },
  watch: {
    selected (val) {
      this.$emit('selection-changed', val)
    }
  }
}
</script>
<style scoped>
.custom-select-table {
  width: 100%;
}

::v-deep .v-data-table__wrapper {
  overflow-x: auto;
  overflow-y: auto; /* enable vertical scrolling */
  max-width: 100%;
  max-height: 75vh; /* use 75% of viewport height so the table adapts to screen size */
  -webkit-overflow-scrolling: touch; /* smooth scrolling on touch devices */
}

::v-deep .v-data-table>.v-data-table__wrapper>table {
  width: max-content;
  min-width: 100%;
}

::v-deep .v-data-table {
  width: 100%;
}

/* 自定义滚动条样式 */
::v-deep .v-data-table__wrapper::-webkit-scrollbar {
  height: 8px;
  width: 8px;
}

::v-deep .v-data-table__wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background: #999;
}
</style>
